import styled from "@emotion/styled";
import { Grid } from '@mui/material';
import { headerHeight } from '../header/header.styled';

export const PageContainerStyled = {
  Container: styled(Grid)<any>`
    display: flex;
    min-height: calc(100vh - ${headerHeight});;
  `,
};
